import { instructorSidebarData } from '../../../core/common/data/json/instructor-sidebar'
import { Link, useLocation } from 'react-router-dom'
const InstructorSidebar = () => {
  const location = useLocation();
  return (
    <div className="col-lg-3 ">
    <div className="settings-sidebar mb-lg-0 theiaStickySidebar">
      <div>
        <h6 className="mb-3">Main Menu</h6>
        <ul className="mb-3 pb-1">
          {instructorSidebarData?.map((menu,index)=>(
            <li key={index}>
            <Link
              to={menu.route}
              className={`d-inline-flex align-items-center ${location.pathname === menu.route || location.pathname === menu.subRoute  ? 'active' : ''}`}
            >
              <i className={`${menu.icon} me-2`} />
              {menu.title}
            </Link>
          </li>
          ))}
          
        </ul>
      </div>
    </div>
  </div>
  )
}

export default InstructorSidebar